document.addEventListener('DOMContentLoaded', function () {
  const accordionTitles = document.querySelectorAll('.footer-accordion-title');

  // Pre-map all accordions
  const accordionItems = Array.from(accordionTitles).map(title => {
    const parent = title.parentElement;
    const content = parent.querySelector('.footer-accordion-content');

    // If active by default, set height
    if (parent.classList.contains('active')) {
      content.style.maxHeight = content.scrollHeight + 'px';
    }

    return { title, parent, content };
  });

  let activeAccordion = accordionItems.find(item => item.parent.classList.contains('active')) || null;

  accordionItems.forEach(({ title, parent, content }) => {
    title.addEventListener('click', () => {
      // Close previously active accordion (if any)
      if (activeAccordion && activeAccordion.parent !== parent) {
        activeAccordion.parent.classList.remove('active');
        activeAccordion.content.style.maxHeight = '0';
      }

      // Toggle current accordion
      const isActive = parent.classList.toggle('active');
      content.style.maxHeight = isActive ? content.scrollHeight + 'px' : '0';

      // Update active reference
      activeAccordion = isActive ? { parent, content } : null;
    });
  });


  const openBtn = document.querySelector('.footer__group-content');
  const overlay = document.querySelector('.newsletter-popup-overlay');
  const closeBtn = document.querySelector('.close-icon-wrapper');

  // If any required element is missing, stop script
  if (!openBtn || !overlay || !closeBtn) {
    return false;
  }
  // Open popup
  openBtn.addEventListener('click', function () {
    overlay.classList.add('active');
  });

  // Close popup when clicking on close button
  closeBtn.addEventListener('click', function () {
    overlay.classList.remove('active');
  });

  // Optional: Close when clicking outside popup
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) {
      overlay.classList.remove('active');
    }
  });
});



